import React from 'react';
import { IAgendaConference } from '../../event/eventInterface';
import Conference from '../../conference/conference';
import { FC } from 'react';
import { IUserDetail } from '../../context/userContext';

export interface AgendaDetailProps {
  conferenceList: IAgendaConference[];
  handleEventSpeakerChange: (index: number, speakerId: string) => void;
  userDetail: IUserDetail;
  eventKey?: string;
}

const AgendaDetail: FC<AgendaDetailProps> = ({
  conferenceList = [],
  handleEventSpeakerChange,
  userDetail,
  eventKey,
}) => (
  <div className="agenda-detail">
    {conferenceList?.map((conference: IAgendaConference) => (
      <Conference
        conference={conference}
        key={conference.title}
        handleEventSpeakerChange={handleEventSpeakerChange}
        userDetail={userDetail}
        eventKey={eventKey}
      />
    ))}
  </div>
);

export default AgendaDetail;
